import axios from "@/plugins/axios";

let url = "/api/v1/me/bookmarks";

export default {
    getBookmarks(data){
        return axios.get(url, data).then(result => result.data);
    },
    getBookmark(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    postBookmark(data){
        return axios.post(url, data).then(result => result.data);
    },
    putBookmark(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    deleteBookmark(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    }
}
